import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { config } from 'utils/config';
import { callApi } from 'utils/utils';
import { Panel } from 'primereact/panel';
import { Dialog } from 'primereact/dialog';
import { Row, Col, Label } from 'reactstrap';
import FieldText from 'components/Controls/FieldText';
import FieldButton from 'components/Controls/FieldButton/FieldButton';
import FieldDropdown from 'components/Controls/FieldDropdown';
import FieldAutoComplete from 'components/Controls/FieldAutoComplete';
import MiscellaneousQueriesAdd from './MiscellaneousQueriesAdd';
import FieldTextArea from 'components/Controls/FieldTextArea';
import FieldNumber from 'components/Controls/FieldNumber';
import FieldCalendar from 'components/Controls/FieldCalendar';

const MiscellaneousQueriesFilters = (props) => {
  const {t, i18n} = useTranslation(['miscellaneousQueries', 'common']);
  const [library, setLibrary] = useState([]);
  const [query, setQuery] = useState([]);
  const [params, setParams] = useState([]);
  const [claTipoConsultaGenerica, setClaTipoConsultaGenerica] = useState(null);
  const [claConsultaGenerica, setClaConsultaGenerica] = useState(null);
  const [idTmpConsultaGenerica, setIdTmpConsultaGenerica] = useState(null);
  const [procedimiento, setProcedimiento] = useState(null);
  const [showNewQuery, setShowNewQuery] = useState(false);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    GetLibrary();
    GetQuery(claTipoConsultaGenerica || 0);
  }, [])

  useEffect(() => {
    const onKeyDown = (e) => {
      if(e.keyCode === 13) {
        updateFilters(false);
      }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [claTipoConsultaGenerica, claConsultaGenerica])

 
  const GetLibrary = () => {
    const urlWebService = `${config.UrlApiProject}IT/GetLibraryCmb`;
    const paramsService = {};
    callApi(urlWebService, 'GET', paramsService, (response) => {
      setLibrary(response.data.LibraryList);
    });
  }

  const GetQuery = (nclaTipoConsultaGenerica) => { 
    const urlWebService = `${config.UrlApiProject}IT/GetQueryCmb?ClaUbicacion=${68}&claTipoConsultaGenerica=${nclaTipoConsultaGenerica}`;
    const paramsService = {};
    callApi(urlWebService, 'GET', paramsService, (response) => {
      setQuery(response.data.QueryList); 
    },null,null,false);
  }

  const GetParams = (sIdTmpConsultaGenerica,nclaConsultaGenerica) => { 
    const urlWebService = `${config.UrlApiProject}IT/GetParamsSel?ClaUbicacion=${68}&IdTmpConsultaGenerica=${sIdTmpConsultaGenerica}&ClaConsultaGenerica=${nclaConsultaGenerica}`;
    const paramsService = {};
    callApi(urlWebService, 'GET', paramsService, (response) => {
      const params = response.data.ParamsList;
      const info = response.data.InfoQuery[0];
      if(info!==undefined){
        setIdTmpConsultaGenerica(info.IdTmpConsultaGenerica);
        setProcedimiento(info.Procedimiento);
      }
      setParams(params);
    },null,null,false);
  }

  const onChangeLibraryFilter = (e) => {
    setClaTipoConsultaGenerica(e.value === undefined ? null : e.value);
    GetQuery(e.value||0);
  }

  const onChangeQueryFilter = (e) => {
    setParams([]);
    setIdTmpConsultaGenerica(null);
    setProcedimiento(null);
    setClaConsultaGenerica(e.value === undefined ? null : e.value);
    if(e.value!==undefined){
      GetParams(idTmpConsultaGenerica||'', e.value);
    }
    updateFilters(true);
  }

  const updateFilters = (esBorrar) => {
    props.setFilters({
      ClaTipoConsultaGenerica: claTipoConsultaGenerica,
      ClaConsultaGenerica: claConsultaGenerica,
      IdTmpConsultaGenerica: idTmpConsultaGenerica,
      EsBorrarInformacion: esBorrar,
      Params: params 
    });
  }

  const onHideNewQuery = () => {
    setShowNewQuery(false);
    updateFilters(false);
  }

  const filterHeaderSettingsTemplate = (options) => {
    const toggleIcon = options.collapsed ? 'pi pi-chevron-down text-white' : 'pi pi-chevron-up text-white';
    const className = `${options.className} p-jc-start`;
    const titleClassName = `${options.titleClassName} p-pl-1`;

    return (
      <div className='card-header'>
        <div className='p-toolbar p-component'>
          <div className='p-toolbar-group-left'>
            <div className='card-title'>
              <FieldButton
                className={options.togglerClassName}
                onClick={options.onTogglerClick}
              >
                <span className={toggleIcon}></span>
              </FieldButton>
              <span className={titleClassName}>
                {t('miscellaneousQueries:Step1Settings')}
              </span>
            </div>
          </div>
          <div className='p-toolbar-group-right'>
            <FieldButton
              hidden={true}
              label={t('miscellaneousQueries:EditParams')}
              className='p-button-info no-border p-mr-2'
              icon='pi pi-pencil'
              onClick={() => setShowNewQuery(true)}
            />&nbsp;
            <FieldButton
              hidden={true}
              label={t('miscellaneousQueries:NewQuerySetUp')}
              className='p-button-warning no-border p-mr-2'
              icon='pi pi-plus'
              onClick={() => setShowNewQuery(true)}
            />
          </div>
        </div>
      </div>
    )
  }

  const filterHeaderFiltersTemplate = (options) => {
    const toggleIcon = options.collapsed ? 'pi pi-chevron-down text-white' : 'pi pi-chevron-up text-white';
    const className = `${options.className} p-jc-start`;
    const titleClassName = `${options.titleClassName} p-pl-1`;

    return (
      <div className='card-header'>
        <div className='p-toolbar p-component'>
          <div className='p-toolbar-group-left'>
            <div className='card-title'>
              <FieldButton
                className={options.togglerClassName}
                onClick={options.onTogglerClick}
              >
                <span className={toggleIcon}></span>
              </FieldButton>
              <span className={titleClassName}>
                {t('miscellaneousQueries:Step2Filters')}
              </span>
            </div>
          </div>

          <div className='p-toolbar-group-right'>
            <FieldButton
              label={t('miscellaneousQueries:RunQuery')}
              className='p-button-success no-border p-mr-2'
              icon='pi pi-play'
              onClick={() => updateFilters(false)}
            />

          </div>
        </div>
      </div>
    )
  }

  
  const handleParamChange = (index, value) => {
    const newParams = [...params];
    const newValue = value;
    if (newParams[index].TipoParametro === 'int') {
      newParams[index].Valor = newValue !== '' ? newValue : null;
    } else {
      newParams[index].Valor = newValue;
    }
    setParams(newParams);
  };


  return (
    <>
      <Panel
        toggleable
        headerTemplate={filterHeaderSettingsTemplate}
      >
        <Row className='p-fluid p-grid p-formgroup-inline align-items-end'> 
          <Col xs={12} sm={12} md={6} lg={3}>
            <div className='p-field'>
              <Label>{t('miscellaneousQueries:Library')}</Label>
              <FieldDropdown
                id='claTipoConsultaGenerica'
                name='claTipoConsultaGenerica'
                placeholder={t('miscellaneousQueries:SelectLibrary')}
                value={claTipoConsultaGenerica}
                options={library}
                optionValue='ClaTipoConsultaGenerica'
                optionLabel='NomTipoConsultaGenerica'
                onChange={onChangeLibraryFilter}
              >
              </FieldDropdown>
            </div>
          </Col>
          <Col xs={12} sm={12} md={6} lg={3}>
            <div className='p-field'>
              <Label>{t('miscellaneousQueries:Query')}</Label>
              <FieldDropdown
                id='claConsultaGenerica'
                name='claConsultaGenerica'
                placeholder={t('miscellaneousQueries:SelectQuery')}
                value={claConsultaGenerica}
                options={query}
                optionValue='ClaConsultaGenerica'
                optionLabel='NomConsultaGenerica'
                onChange={onChangeQueryFilter}
              >
              </FieldDropdown>
            </div>
          </Col>
        </Row>
        <Row 
          /* hidden={params.length===0} */
          className='p-fluid p-grid p-formgroup-inline align-items-end'
        > 
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className='p-field'>
              <Label>{t('miscellaneousQueries:QueryDescription')}</Label>
              <FieldTextArea
                name="Procedimiento"
                rows={5}
                placeholder=""
                value={procedimiento}
                maxLength={3000}
                errors={errors}
                disabled={true}
              />
            </div>
          </Col>
        </Row>
      </Panel>
      &nbsp;
      <Panel
        style={{ display: params.length === 0 ? 'none' : 'block' }}
        toggleable
        headerTemplate={filterHeaderFiltersTemplate}
      >
        <Row className='p-fluid p-grid p-formgroup-inline align-items-end pt-3 pb-2'> 
          {params.map((param, index) => (
            <Col className='pt-2' key={index} xs={12} md={6} lg={4}>
              <div className='p-field'>
                {param.TipoParametro === 'varchar' && (
                <FieldText
                  value={param.Valor || ''}
                  label={param.NomLogicoParam}
                  onChange={(e) => handleParamChange(index, e.target.value)}
                  placeholder={param.Descripcion}
                  maxLength={param.LongParametro}
                />
                    )}
                {param.TipoParametro === 'int' && (
                <FieldNumber
                  value={param.Valor || ''}
                  label={param.NomLogicoParam}
                  onChange={(e) => handleParamChange(index, e.target.value)}
                  placeholder={param.Descripcion}
                  useGrouping={false}
                />
                    )}
                {param.TipoParametro === 'text' && (
                <FieldTextArea
                  value={param.Valor || ''}
                  label={param.NomLogicoParam}
                  onChange={(e) => handleParamChange(index, e.target.value)}
                  placeholder={param.Descripcion}
                  maxLength={param.LongParametro}
                />
                    )}
                {param.TipoParametro === "datetime" && (
                <FieldCalendar
                  value={(param.Valor!== null ? (new Date(param.Valor)): null)}
                  label={param.NomLogicoParam}
                  onChange={(e) => handleParamChange(index, e.value)}
                  placeholder={param.Descripcion}
                  showIcon
                />
              )}
                {param.TipoParametro === "date" && (
                <FieldCalendar
                  value={(param.Valor!== null ? (new Date(param.Valor)): null)}
                  label={param.NomLogicoParam}
                  onChange={(e) => handleParamChange(index, e.value)}
                  placeholder={param.Descripcion}
                  showIcon
                />
              )}
                {param.TipoParametro === 'char' && (
                <FieldText
                  value={param.Valor || ''}
                  label={param.NomLogicoParam}
                  onChange={(e) => handleParamChange(index, e.target.value)}
                  placeholder={param.Descripcion}
                  maxLength={param.LongParametro}
                />
                    )}
              </div>
            </Col>
        ))}
        </Row> 
      </Panel>
      <Dialog
        visible={showNewQuery}
        onHide={() => {
          setShowNewQuery(false);
          setErrors([]);
        }}
        className='dialog-header-background-blue'
        contentClassName='p-1'
        header={t('miscellaneousQueries:NewQuerySetUp')}
        style={{ width: '30vw' }}
        blockScroll={true}
      >
        <MiscellaneousQueriesAdd onHide={onHideNewQuery} />
      </Dialog>
    </>
  )
}

export default MiscellaneousQueriesFilters;